<template>
  <!-- <section class="section has-background-image has-background-primary-light is-centered"> -->

  <vue-flux
    style="z-index:0"
    :options="vfOptions"
    :images="vfImages"
    :transitions="vfTransitions"
    ref="slider"
  >
  <template v-slot:caption>
  <div class="container" style="padding:5rem;z-index:10">
      <div class="columns is-desktop is-vcentered">
	<div class="column is-half ">
	  <InfoBox />	  
	</div>
  <div class="column is-half ">
        <form  @submit.prevent="gotoSearch">
          <b-field>
            <b-input
              v-on:keyup.enter="gotoSearch"
              v-model="queryTerm"
              :expanded="true"
              :placeholder='$t("Search...")'
              type="search"
              icon="search"
            ></b-input>
            <p class="control">
              <b-button  type="is-primary" @click="gotoSearch">{{ $t("Search") }}</b-button>
            </p>
          </b-field>
        </form>
	</div>
  
      </div>
    </div>
    </template>
    
    <template v-slot:pagination>
      <flux-pagination />
    </template>

    <template v-slot:index>
      <flux-index />
    </template>
  </vue-flux>
</template>

<style>
.has-background-image {
  background-image: url("~@/assets/background.jpg");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: top center;
  position: relative;
}
.is-centered {
  display: flex;
  align-items: center;
}

</style>

<script>
import InfoBox from "@/components/InfoBox.vue";
import {
  VueFlux,
  FluxCaption,
  FluxControls,
  FluxIndex,
  FluxPagination,
  FluxPreloader,
} from "vue-flux";

import { createMapper } from "@/utils/mapping.js";
const mapper = createMapper("search-form");

export default {
  components: {
    InfoBox,
    VueFlux,
    FluxCaption,
    FluxControls,
    FluxIndex,
    FluxPagination,
    FluxPreloader,
  },
  computed: {
    query() {
      return mapper.toURL({ term: this.term });
    },
    searchQuery() {
      return mapper.toURL({
        term: this.queryTerm,
      });
    },
    searchPageRoute() {
      // FIXME: use from global definition
      return {
        name: "Search",
        query: this.searchQuery,
      };
    },
  },
  data() {
    return {
      term: "",
      queryTerm: "",
      vfOptions: {
        autoplay: true,
      },
      vfImages: [
        require('@/assets/background_1.jpg'),
        require('@/assets/background_2.jpg'),
        require('@/assets/background_3.jpg'),
        require('@/assets/background_4.jpg'),
        require('@/assets/background_5.jpg'),
        require('@/assets/background_6.jpg'),
        require('@/assets/background_7.jpg'),
        require('@/assets/background_8.jpg'),
        require('@/assets/background_9.jpg'),
        require('@/assets/background_10.jpg'),
        require('@/assets/background_11.jpg'),
        require('@/assets/background_12.jpg'),
        require('@/assets/background_13.jpg'),
        require('@/assets/background_14.jpg'),
        require('@/assets/background_15.jpg'),
        require('@/assets/background_16.jpg'),
        require('@/assets/background_17.jpg'),
        require('@/assets/background_18.jpg'),
        require('@/assets/background_19.jpg'),
      ],
      vfTransitions: ["fade"],
    };
  },
  methods: {
    gotoSearch() {
      this.$router.push(this.searchPageRoute);
    },
  },
};
</script>
